import { ApexChartWidget } from './apex-chart-widget';
import { ChartDataXY, ChartSeriesXY } from '../data/chart-data-types';
import { customElement, property } from 'lit/decorators.js';
import { getQuoteStatusStr } from '../../../quotes/data/quote-helper-functions';
import { issuedQuotesCache } from '../data/issued-quotes-cache';
import { localDateTimeToServer } from '../../../../webmodule-common/other/datetime-converter';

import { NullPromise } from '../../../../webmodule-common/interop/webmodule-interop';
import { QuoteState, ResultGetIssuedQuoteRevenue } from '../../../api/dealer-api-interface-quote';

import { LangIssuedQuotesWidget } from '../../../../localization/scripts/dealer-franchisee/dashboard/widget/issued-quotes-widget-lang';

@customElement('issued-quotes-revenue-widget')
export class GeneratedQuotesWidget extends ApexChartWidget {
  chart: any | null = null;

  @property({ type: Array }) states: QuoteState[] = [
    QuoteState.Draft,
    QuoteState.Active,
    QuoteState.IssuePending,
    QuoteState.Issued,
    QuoteState.Accepted,
    QuoteState.Accepted_AssignedToReviewer,
    QuoteState.SupplierReviewPending,
    QuoteState.SupplierReviewed,
    QuoteState.Approved
  ];

  private _cache = issuedQuotesCache();
  constructor() {
    super('quote-issued-revenue');
  }

  protected async refreshData(): NullPromise<ResultGetIssuedQuoteRevenue> {
    if (this.dateRange) {
      const startDate = localDateTimeToServer(this.dateRange.startDate);
      const endDate = localDateTimeToServer(this.dateRange.endDate);
      const result = await this._cache?.getData(startDate, endDate, this.states, this.branchId, this.userId);
      if (result) {
        return result;
      }
    }
    return null;
  }

  protected getTitle(): string {
    return LangIssuedQuotesWidget.quoteNetAmount({ label: this.dateRange?.label ?? '' });
  }

  protected getSeriesColorByState(state: number): string {
    // return the corresponding badge colour
    switch (state as QuoteState) {
      case QuoteState.Draft:
        return '#0ea5e9';
      case QuoteState.Active:
        return '#d946ef';
      case QuoteState.IssuePending:
      case QuoteState.SupplierReviewPending:
        return '#a855f7';
      case QuoteState.Issued:
        return '#eab308';
      case QuoteState.SupplierReviewed:
        return '#06b6d4';
      case QuoteState.Accepted:
      case QuoteState.Accepted_AssignedToReviewer:
        return '#84cc16';
      case QuoteState.Approved:
        return '#f97316';
      default:
        return '#3282cc'; // base colour
    }
  }

  protected updateData(): void {
    this.refreshData().then(results => {
      if (results) {
        const chartSeries: ChartSeriesXY[] = [];

        for (const quoteState of results.quoteStates) {
          const chartData: ChartDataXY[] = [];
          const data = results.revenueSummary.filter(d => d.state === quoteState || d.state === -1);
          data.map(r =>
            chartData.push({
              x: this.convertDateToMillis(r.date),
              y: r.dailyRevenue
            })
          );
          chartSeries.push({
            name: LangIssuedQuotesWidget.quoteStatus({ status: getQuoteStatusStr(quoteState) }),
            data: chartData,
            color: this.getSeriesColorByState(quoteState)
          });
        }
        if (this.chart.series) {
          this.chart.updateSeries(chartSeries, true);
        }
      }
    });
  }
}
